module.exports = __webpack_public_path__ + "img/logo2.d2c1a3cd.png";